import React from 'react'
import { List } from 'immutable'
import isEqual from 'lodash/isEqual'
import SelectList from 'components/common/SelectList'
import { formatMessage } from 'lib/intl'
import { ALL_SELECTED, EMPTY } from 'constants/index'
import { getExistedValue } from '../Common/utils'

function JobsFilter({ jobList, workflows, setWorkflows, saveFilter }) {
  const value =
    jobList && jobList.length ? getExistedValue(workflows, jobList) : []
  const getAllSelected = () => jobList && jobList.map(item => item.id)
  const handleJobChange = value => {
    let selected

    if (value === ALL_SELECTED) {
      selected = getAllSelected()
    } else if (value === EMPTY) {
      selected = []
    } else {
      selected = value.map(item => item && item.index)
    }

    if (!isEqual(selected, workflows)) {
      const filteredSelected = selected.filter(item => !!item)
      setWorkflows(filteredSelected)
      saveFilter({ workflows: filteredSelected })
    }
  }

  return (
    <SelectList
      multiple
      withCheckBox
      hasAllValueOption
      outMultipleValues={{
        all: ALL_SELECTED,
        empty: EMPTY,
      }}
      variant="outlined"
      name="jobs"
      label={formatMessage('jobs')}
      list={List(jobList)}
      value={value}
      onClose={handleJobChange}
      map={{
        index: 'id',
        text: 'title',
      }}
    />
  )
}

export default JobsFilter
